import { render } from "./UMData.vue?vue&type=template&id=43a6349d&scoped=true"
import script from "./UMData.vue?vue&type=script&lang=js"
export * from "./UMData.vue?vue&type=script&lang=js"

import "./UMData.vue?vue&type=style&index=0&id=43a6349d&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43a6349d"]])

export default __exports__